import { ConfigPublic } from '@/common/config.public';
import { ImgExtension } from '@/common/types/Artwork/Artwork.type';
import { ArtworkOrientation } from 'generatedBfw/static';

export interface ImageResolution {
  longSide: number;
  shortSide: number;
}

interface ArtworkResolutionRectListType {
  rect190x135: ImageResolution;
  rect227x162: ImageResolution;
  rect255x182: ImageResolution;
  rect320x230: ImageResolution;
  rect380x270: ImageResolution;
  rect392x280: ImageResolution;
  rect387x183: ImageResolution;
  rect454x324: ImageResolution;
  rect640x460: ImageResolution;
  rect711x594: ImageResolution;
  rect784x560: ImageResolution;
  rect992x832: ImageResolution;
  rect1200x857: ImageResolution;
  rect1422x1188: ImageResolution;
  rect1422x1016: ImageResolution;
  rect2844x2032: ImageResolution;
}

interface ArtworkResolutionSquareListType {
  square124: ImageResolution;
  square163: ImageResolution;
  square400: ImageResolution;
  square600: ImageResolution;
  square1200: ImageResolution;
}

interface ArtworkResolutionListType {
  rect: ArtworkResolutionRectListType;
  square: ArtworkResolutionSquareListType;
}

/**
 * Displate prerendered image sizes
 */
export const ArtworkResolutions: ArtworkResolutionListType = {
  rect: {
    rect190x135: { longSide: 190, shortSide: 135 },
    rect227x162: { longSide: 227, shortSide: 162 },
    rect255x182: { longSide: 255, shortSide: 182 },
    rect320x230: { longSide: 320, shortSide: 230 },
    rect380x270: { longSide: 380, shortSide: 270 },
    rect392x280: { longSide: 392, shortSide: 280 },
    rect387x183: { longSide: 387, shortSide: 183 },
    rect454x324: { longSide: 454, shortSide: 324 },
    rect640x460: { longSide: 640, shortSide: 460 },
    rect711x594: { longSide: 711, shortSide: 594 },
    rect784x560: { longSide: 784, shortSide: 560 },
    rect992x832: { longSide: 992, shortSide: 832 },
    rect1200x857: { longSide: 1200, shortSide: 857 },
    rect1422x1188: { longSide: 1422, shortSide: 1188 }, // this doesn't work
    rect1422x1016: { longSide: 1422, shortSide: 1016 },
    rect2844x2032: { longSide: 2844, shortSide: 2032 },
  },
  square: {
    square124: { longSide: 124, shortSide: 124 },
    square163: { longSide: 163, shortSide: 163 },
    square400: { longSide: 400, shortSide: 400 },
    square600: { longSide: 600, shortSide: 600 },
    square1200: { longSide: 1200, shortSide: 1200 },
  },
};

export const imageCoreToUrl = (
  imageCoreUrl: string,
  resolution: ImageResolution,
  orientation: ArtworkOrientation,
): string => {
  if (!imageCoreUrl) return '';

  let resolutionStr: string;
  if (orientation === ArtworkOrientation.HORIZONTAL) {
    resolutionStr = `${resolution.longSide}x${resolution.shortSide}`;
  } else {
    resolutionStr = `${resolution.shortSide}x${resolution.longSide}`;
  }

  const domain = ConfigPublic.ArtworkDomain;
  return [domain, resolutionStr, 'displate', imageCoreUrl].join('/');
};

export const imageCoreToSeoImage = (imageCoreUrl: string): string => {
  if (!imageCoreUrl) return '';

  const visualization = ConfigPublic.VisualizationArtworkBaseUrl;
  return [visualization, imageCoreUrl].join('/');
};

export const imageCoreToAsset = (imageCoreUrl: string, assetPath: string): string => {
  if (!imageCoreUrl || !assetPath) return '';

  const domain = ConfigPublic.ArtworkDomain;
  return [domain, assetPath, imageCoreUrl].join('/');
};

export const addImageExtension = (src: string, extension: ImgExtension = 'jpg') => {
  return src.includes(`.${extension}`) ? src : `${src}.${extension}`;
};
